import React, { useEffect, useState } from 'react';

const Footer: React.FC = () => {
  const [footerText, setFooterText] = useState('');

  useEffect(() => {
    // Anti-crawling: Generate text with JavaScript (most crawlers don't execute JS)
    // Encoded contact information - decoded on client side
    const encoded = [
      '65', '112', '112', '115', '116', '111', '114', '105', '97', '32', '73', 
      '110', '99', '46', '32', '52', '50', '50', '48', '32', '83', '111', '117', 
      '116', '104', '32', '77', '97', '114', '121', '108', '97', '110', '100', 
      '32', '80', '97', '114', '107', '119', '97', '121', '44', '32', '50', 
      '110', '100', '32', '70', '108', '111', '111', '114', '32', '76', '97', 
      '115', '32', '86', '101', '103', '97', '115', '44', '32', '78', '101', 
      '118', '97', '100', '97', '44', '32', '56', '57', '49', '49', '57', '44', 
      '32', '85', '83', '65'
    ];
    
    // Decode the contact information
    const decoded = encoded.map(code => String.fromCharCode(parseInt(code))).join('');
    
    // Small delay to further prevent automated parsing
    setTimeout(() => {
      setFooterText(decoded);
    }, 100);
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <span 
          className="footer-text-protected"
          style={{ 
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            pointerEvents: 'none',
            fontFamily: 'inherit'
          }}
          aria-label="Contact information"
        >
          {footerText}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
